<script setup lang="ts">
import {
  DocumentDuplicateIcon,
  CheckCircleIcon,
} from '@heroicons/vue/24/solid';

const authStore = useAuthStore();

const copiedIndex = ref<null | number>(null);

const properties = computed(() => [
  { property: 'user_id', display: 'Account Id' },
  { property: 'access_token', display: 'Access token' },
  { property: 'getMobileNumber', display: 'Mobile number' },
]);

function copyToClipboard(text: string, index: number) {
  copiedIndex.value = index;
  navigator.clipboard.writeText(text);
  setTimeout(() => (copiedIndex.value = null), 500);
}
</script>

<template>
  <div class="card justify-center">
    <div
      v-for="(property, index) in properties"
      :key="index"
      class="text-xs text-base-priority"
    >
      <div>
        <b>{{ property.display }}</b>
        :
      </div>
      <div class="flex justify-between items-center gap-2">
        <div class="line-clamp-1">{{ authStore[property.property] }}</div>
        <component
          :is="copiedIndex === index ? CheckCircleIcon : DocumentDuplicateIcon"
          :key="index"
          class="min-w-6 max-w-6 cursor-pointer"
          @click="copyToClipboard(authStore[property.property], index)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
